import {
  Box,
  Button,
  Container,
  Grid2,
  Menu,
  MenuItem,
  Pagination,
  PaginationItem,
  Stack,
  Typography,
} from "@mui/material";
import DrawHeroComponent from "./drawdetails/component/DrawHeroComponent";

import { styles } from "./styles";
import { useState, useEffect } from "react";
import { BiFilterAlt } from "react-icons/bi";
import theme from "../../theme/Theme";
import { GoChevronLeft, GoChevronRight } from "react-icons/go";
import DrawTicketComponent from "../../component/DrawTicketComponent";
import { fetchDrawList } from "../../api/ApiService";
import NoDataFound from "../../assets/svg/NoDataFound";

const DrawPage = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [drawsData, setDrawsData] = useState([]);
  const [originalList, setOriginalList] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState("Active Draw");
  const [filterMenuOpen, setFilterMenuOpen] = useState(null);
  const filterOpen = Boolean(filterMenuOpen);
  const [sortMenuOpen, setSortMenuOpen] = useState(false);
  const [sortMenu, setSortMenu] = useState(null);
  const sortOpen = Boolean(sortMenuOpen);



  const itemsPerPage = 6;
  const [totalPages, setTotalPages] = useState(1);
  const [filteredTotal, setFilteredTotal] = useState(0);
  const startIdx = (currentPage - 1) * itemsPerPage;

  const getDrawsListData = async () => {
    const response = await fetchDrawList();
    if (response && response.data) {
      const drawListArray = response.data;
      setOriginalList(drawListArray);
    }
  };
  const sortAndFilter = () => {
    const now = new Date();
    const allActiveDraws = originalList
      .filter((draw) => new Date(draw.endTime) > now)
      .sort((a, b) => new Date(a.endTime) - new Date(b.endTime));

    const allExpiredDraws = originalList
      .filter((draw) => new Date(draw.endTime) < now)
      .sort((a, b) => new Date(a.endTime) - new Date(b.endTime));

    const allUpcomingDraws = originalList
      .filter((draw) => new Date(draw.startTime) > now)
      .sort((a, b) => new Date(a.endTime) - new Date(b.endTime));

    let filteredDraws = [];

    if (selectedFilter === null) {
      filteredDraws = allActiveDraws.concat(allExpiredDraws);
    } else if (selectedFilter === "Active Draw") {
      filteredDraws = allActiveDraws;
    } else if (selectedFilter === "Completed Draw") {
      filteredDraws = allExpiredDraws;
    } else if (selectedFilter === "Upcoming Draw") {
      filteredDraws = allUpcomingDraws;
    } else {
      filteredDraws = originalList;
    }

    const totalItems = filteredDraws.length;
    const computedTotalPages =
      totalItems > 0 ? Math.ceil(totalItems / itemsPerPage) : 1;
    const safePage = Math.min(currentPage, computedTotalPages);
    const startIndex = (safePage - 1) * itemsPerPage;

    const paginatedItems = filteredDraws.slice(
      startIndex,
      Math.min(startIndex + itemsPerPage, filteredDraws.length)
    );

    if (safePage !== currentPage) {
      setCurrentPage(safePage);
    }

    setFilteredTotal(totalItems);
    setTotalPages(computedTotalPages);
    setDrawsData(paginatedItems);
  };
  useEffect(() => {
    if (originalList) {
      sortAndFilter();
    }
  }, [originalList, currentPage, filterMenuOpen, selectedFilter]);
  useEffect(() => {
    getDrawsListData();
  }, []);
  const handleFilterMenuClick = (event) => {
    setFilterMenuOpen(event.currentTarget);
  };

  const handleFilterMenuClose = () => {
    setFilterMenuOpen(null);
  };

  const handleSortMenuClick = (event) => {
    setSortMenuOpen(event.currentTarget);
  };

  const handleSortMenuClose = () => {
    setSortMenuOpen(null);
  };

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const handleFilterMenuItemClick = (item) => {
    setSelectedFilter(item);
    setCurrentPage(1);
    setFilterMenuOpen(null);
  };

  const handleSortMenuItemClick = (item) => {
    setSortMenu(item);
    setSortMenuOpen(null);
  };

  return (
    <Box>
      <DrawHeroComponent />
      <Container maxWidth="xl" sx={{ py: 3 }}>
        <Box sx={styles.itemAlignJustify}>
          <Typography sx={styles.paginationCurrentPageText}>
            {`Showing ${currentPage}-${totalPages} of ${filteredTotal} Result${
              filteredTotal === 1 ? "" : "s"
            }`}
          </Typography>
          <Stack direction={"row"} alignItems={"center"} gap={2}>
            <Button
              aria-controls={filterOpen ? "filter-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={filterOpen ? "true" : undefined}
              onClick={handleFilterMenuClick}
              startIcon={<BiFilterAlt color={theme.palette.text.primary} />}
              sx={styles.filterSortButton}
            >
              Filter{selectedFilter ? " - " + selectedFilter : ""}
            </Button>
            <Menu
              id="filter-menu"
              anchorEl={filterMenuOpen}
              open={filterOpen}
              onClose={handleFilterMenuClose}
              sx={{
                "& .MuiPaper-root": {
                  border: `1px solid ${theme.palette.primary.main}`, // Customize the border here
                  borderRadius: "8px", // Optional: Add rounded corners
                },
              }}
              MenuListProps={{
                "aria-labelledby": "filter-menu",
              }}
            >
              <MenuItem
                onClick={() => handleFilterMenuItemClick(null)}
                sx={styles.drawFilterMenuItem}
              >
                All Draws
              </MenuItem>
              <MenuItem
                onClick={() => handleFilterMenuItemClick("Active Draw")}
                sx={styles.drawFilterMenuItem}
              >
                Active Draw
              </MenuItem>
              <MenuItem
                onClick={() => handleFilterMenuItemClick("Upcoming Draw")}
                sx={styles.drawFilterMenuItem}
              >
                Upcoming Draw
              </MenuItem>
              <MenuItem
                onClick={() => handleFilterMenuItemClick("Completed Draw")}
                sx={styles.drawFilterMenuItem}
              >
                Completed Draw
              </MenuItem>
            </Menu>
          </Stack>
        </Box>
        <Grid2 container spacing={3} mt={4}>
          {drawsData && drawsData.length > 0 ? (
            drawsData.map((item, index) => (
              <Grid2 item size={{ xs: 12, md: 6, lg: 4 }} key={index}>
                <DrawTicketComponent item={item} index={index} />
              </Grid2>
            ))
          ) : (
            <Grid2 item size={{ xs: 12, md: 12, lg: 12 }}>
              <Box sx={styles.noRecordContainer}>
                <NoDataFound sx={styles.noRecordImage} />
                <Typography sx={styles.noRecordText}>No draws found</Typography>
              </Box>
            </Grid2>
          )}
        </Grid2>
        <Box sx={styles.itemAlignCenter} mt={4}>
          <Pagination
            count={totalPages}
            shape="rounded"
            size="large"
            sx={styles.pagination}
            onChange={handlePageChange}
            renderItem={(item) => (
              <PaginationItem
                {...item}
                sx={{
                  backgroundColor: item.selected
                    ? theme.custom.white
                    : theme.palette.primary.main,
                  borderColor: item.selected
                    ? theme.palette.primary.main
                    : theme.custom.white,
                  borderWidth: item.selected ? "2px" : "1px",
                  borderRadius: "12px",
                  color: item.selected
                    ? theme.palette.primary.main
                    : theme.custom.white,
                  "&:hover": {
                    backgroundColor: theme.palette.primary.main,
                  },
                  ...(item.type === "previous" || item.type === "next"
                    ? {
                      backgroundColor: "transparent",
                      color: theme.palette.primary.main,
                      borderRadius: "12px",
                      "&:hover": {
                        backgroundColor: "rgba(255, 162, 156, 0.7)",
                        color: theme.palette.primary.main,
                      },
                    }
                    : {}),
                }}
              />
            )}
          />
        </Box>
      </Container>
    </Box>
  );
};
export default DrawPage;
